import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { NotifyComponent } from '../../shared/notify/notify.component';


@Injectable()
export class NotifyService {
  config: MatSnackBarConfig;
  constructor(public snackBar: MatSnackBar) {
    this.config = new MatSnackBarConfig();
    this.config.duration = 5000;
    this.config.horizontalPosition = 'right';
    this.config.verticalPosition = 'top';
    this.config.panelClass = ['success'];
  }

  error(message: string, title?: string, duration?: number) {
    this.config.panelClass = 'error';
    this.config.duration = duration || this.config.duration;
    this.config.data = {
      icon: 'fa-exclamation-circle',
      title: title || '',
      message: message,
      close: this.snackBar.dismiss
    };
    this.snackBar.openFromComponent(NotifyComponent, this.config);
  }

  success(message: string, title?: string, duration?: number) {
    this.config.panelClass = 'success';
    this.config.duration = duration || this.config.duration;
    this.config.data = {
      icon: 'fa-check-circle',
      title: title || '',
      message: message,
      close: this.snackBar.dismiss
    };
    this.snackBar.openFromComponent(NotifyComponent, this.config);
  }

  warning(message: string, title?: string, duration?: number) {
    this.config.panelClass = 'warning';
    // this.config.panelClass = 'bg-danger';
    this.config.duration = duration || this.config.duration;
    this.config.data = {
      icon: 'fa-exclamation-triangle',
      title: title || '',
      message: message,
      close: this.snackBar.dismiss
    };
    this.snackBar.openFromComponent(NotifyComponent, this.config);
  }

  info(message: string, title?: string, duration?: number) {
    this.config.panelClass = ['info'];
    this.config.duration = duration || this.config.duration;
    this.config.data = {
      icon: 'fa-info-circle',
      title: title || '',
      message: message,
      close: this.snackBar.dismiss
    };
    this.snackBar.openFromComponent(NotifyComponent, this.config);
  }

  fixed(message: string, title?: string) {
    this.config.panelClass = ['warning'];
    this.config.duration = 3.154e+10;
    this.config.data = {
      icon: 'fa-exclamation-triangle',
      title: title || '',
      message: message,
      close: this.snackBar.dismiss
    };
    this.snackBar.openFromComponent(NotifyComponent, this.config);
  }

  eliminar() {
    this.success('Eliminado satisfactoriamente');
  }

  agregar() {
    this.success('Agregado satisfactoriamente');
  }

  modificar() {
    this.success('Modificado satisfactoriamente');
  }

  exportar() {
    this.success('Exportado satisfactoriamente');
  }

  procesar() {
    this.success('Procesado satisfactoriamente');
  }

  aprobar() {
    this.success('Aprobado satisfactoriamente');
  }

  rechazar() {
    this.success('Rechazado satisfactoriamente');
  }

  realizar() {
    this.success('Realizado satisfactoriamente');
  }

  ejecutar() {
    this.success('Ejecutado satisfactoriamente');
  }

}
